import { useSelector } from 'react-redux'
import type { InternalPermission } from 'src/constants/internal-access/internalPermissions'
import { getInternalIdentity } from 'src/selectors/internalAuth'
import { hasPermission } from 'src/utils/internalAccess/hasPermission'

/**
 * Client gating only hides what the server would refuse — the backend's `@InternalAuth` is the
 * authority. Every route renders behind `RequireInternalAuth`, so the identity is loaded by then.
 */
export const useHasPermission = (permission: InternalPermission): boolean => {
  const identity = useSelector(getInternalIdentity)

  return hasPermission(identity, permission)
}
